module.exports = __webpack_public_path__ + "static/media/convex_instruct.cfd6557e.gif";